import { functions } from "../firebase";

export type ArtifactEventTotals = {
  artifact_view: number;
  artifact_start: number;
  artifact_complete: number;
  artifact_share: number;
  artifact_cta: number;
  artifact_remix_created: number;
  artifact_signup_attributed: number;
  artifact_community_join_attributed: number;
};
export type ArtifactDashboardRow = {
  id: string;
  status: "active" | "revoked";
  title: string;
  kind: string;
  url: string | null;
  publishedAt: string | null;
  revokedAt: string | null;
  source: {
    planId: string | null;
    planTitle: string | null;
    stepId: string | null;
  };
  totals: ArtifactEventTotals;
  lifetimeTotals: ArtifactEventTotals;
};

export type ArtifactDashboardSource = {
  key: string;
  planId: string | null;
  planTitle: string;
  stepId: string | null;
  stepTitle: string;
  publications: number;
  totals: ArtifactEventTotals;
};

export type ArtifactDashboard = {
  communityId: string;
  generatedAt: string;
  range: {
    days: number;
    startDay: string;
    endDay: string;
  };
  canEdit: boolean;
  truncated: boolean;
  summary: {
    publications: number;
    activePublications: number;
    totals: ArtifactEventTotals;
    lifetimeTotals: ArtifactEventTotals;
  };
  daily: Array<{
    day: string;
    events: ArtifactEventTotals;
  }>;
  artifacts: ArtifactDashboardRow[];
  sources: ArtifactDashboardSource[];
  kinds: Array<{
    kind: string;
    publications: number;
    totals: ArtifactEventTotals;
  }>;
};

export const getArtifactDashboard = async (
  communityId: string,
  days: number
): Promise<ArtifactDashboard> => {
  const callable = functions.httpsCallable("getArtifactDashboard");
  const result = await callable({ communityId, days });
  return result.data as ArtifactDashboard;
};

export const revokeArtifactPublicationAsCoach = async (
  communityId: string,
  publicationId: string
): Promise<{
  publicationId: string;
  status: "revoked";
  revokedAt: string | null;
  alreadyRevoked: boolean;
}> => {
  const callable = functions.httpsCallable(
    "revokeArtifactPublicationAsCoach"
  );
  const result = await callable({ communityId, publicationId });
  return result.data as {
    publicationId: string;
    status: "revoked";
    revokedAt: string | null;
    alreadyRevoked: boolean;
  };
};
